/**
 * Config API Client
 *
 * 백엔드 설정값 조회 (전략 실행 주기, UI 갱신 주기 등)
 */
import { fetchJson } from './apiErrorHandler';
import { API_BASE_URL } from '../config';

/**
 * 설정 주기 인터페이스
 */
export interface ConfigIntervals {
  strategy_execution_interval: number;  // 초 단위
  ui_refresh_interval: number;  // 초 단위
}

/**
 * 전략 실행 및 UI 갱신 주기 조회
 *
 * @returns 설정값 (초 단위)
 * @throws ApiError
 */
export async function getIntervals(): Promise<ConfigIntervals> {
  return fetchJson<ConfigIntervals>(
    `${API_BASE_URL}/api/config/intervals`,
    undefined,
    '설정 조회'
  );
}
